import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@/hooks/useTranslation";
import { useLanguage } from "@/contexts/LanguageContext";

const DemoCallForSolutionsQuebecForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { currentLanguage, setLanguage } = useLanguage();
  
  return (
    <div className="min-h-screen bg-white flex flex-col items-center p-4 pb-12">
      {/* Language Buttons */}
      <div className="w-full max-w-4xl flex justify-end mb-4">
        <div className="flex space-x-1">
          <button
            onClick={() => setLanguage('EN')}
            className={`px-2 py-1 text-xs rounded transition-colors ${
              currentLanguage === 'EN' 
                ? 'bg-gray-600 text-white' 
                : 'bg-gray-400 text-white hover:bg-gray-500'
            }`}
            title="Switch to English"
          >
            EN
          </button>
          <button
            onClick={() => setLanguage('FR')}
            className={`px-2 py-1 text-xs rounded transition-colors ${
              currentLanguage === 'FR' 
                ? 'bg-gray-600 text-white' 
                : 'bg-gray-400 text-white hover:bg-gray-500'
            }`}
            title="Switch to French"
          >
            FR
          </button>
          <button
            onClick={() => setLanguage('SP')}
            className={`px-2 py-1 text-xs rounded transition-colors ${
              currentLanguage === 'SP' 
                ? 'bg-gray-600 text-white' 
                : 'bg-gray-400 text-white hover:bg-gray-500'
            }`}
            title="Switch to Spanish"
          >
            SP
          </button>
        </div>
      </div>
      
      {/* Logo */}
      <div className="mt-8 mb-6">
        <img 
          src="/lovable-uploads/bb3f5ac9-6c4b-494d-9a60-86ee7a3feb77.png" 
          alt="iSPAI Logo" 
          className="h-16 cursor-pointer" 
          onClick={() => navigate("/quebec-channel")} 
        />
      </div>

      {/* Title */}
      <h1 className="text-3xl font-bold text-black mb-8 text-center">
        {t("demo.quebec.title")}
      </h1>

      <div className="w-full max-w-4xl">
        {/* Purpose Card */}
        <Card className="mb-8 border border-gray-200">
          <CardContent className="pt-6">
            <h2 className="text-xl font-semibold text-center mb-4">{t("demo.quebec.purpose")}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t("demo.quebec.purposeText")}
            </p>
          </CardContent>
        </Card>

        {/* Instructions Card */}
        <Card className="mb-8 border border-gray-200">
          <CardContent className="pt-6">
            <h2 className="text-xl font-semibold text-center mb-4">{t("demo.quebec.instructions")}</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold">{t("demo.quebec.step1Title")}</h3>
                <p className="text-gray-700 ml-5 mt-1">{t("demo.quebec.step1Text")}</p>
              </div>

              <div>
                <h3 className="font-semibold">{t("demo.quebec.step2Title")}</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  {t("demo.quebec.step2Text")}
                </p>
              </div>

              <div>
                <h3 className="font-semibold">{t("demo.quebec.step3Title")}</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  {t("demo.quebec.step3Text")}
                </p>
              </div>

              <div>
                <h3 className="font-semibold">{t("demo.quebec.step4Title")}</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  {t("demo.quebec.step4Text")}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Next Button */}
        <div className="flex justify-center mt-8">
          <Button 
            className="bg-[#14213d] hover:bg-[#0d1829] text-white px-8 py-2 rounded" 
            onClick={() => navigate("/demo-call-for-solutions-quebec/functional-area")}
          >
            {t("demo.quebec.nextButton")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DemoCallForSolutionsQuebecForm;